var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternBackgroundDesktopDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 960,
    fill: "none",
    viewBox: "0 0 1440 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -50.5,
    cy: 75.5,
    r: 416.5,
    stroke: "#2D3949",
    strokeWidth: 144
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1388.5,
    cy: 840.5,
    r: 416.5,
    stroke: "#2D3949",
    strokeWidth: 144
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternBackgroundDesktopDark);
export default __webpack_public_path__ + "static/media/pattern-background-desktop-dark.e211d976d5b431130f8202dd6c8de661.svg";
export { ForwardRef as ReactComponent };